<template>
  <j-modal
    :title="title"
    :visible="visible"
    width="50%"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel"
    @ok="handleOk"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :title="$t('问题详情')">
                <a-descriptions-item :label="$t('上报人')">{{ model.informant }}</a-descriptions-item>
                <a-descriptions-item :label="$t('上报人电话')">{{ model.informantPhone }}</a-descriptions-item>
                <a-descriptions-item :label="$t('现场坐标')">{{ model.coordinate }}</a-descriptions-item>
                <a-descriptions-item :label="$t('问题等级')">{{
                    filterDictTextByCache('problemLevel',model.problemLevel)
                  }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备编号')">{{ model.deviceNum }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备名称')">{{ model.deviceName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备类型')">{{
                  filterDictTextByCache('deviceType', model.deviceType)
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('创建时间')">{{ model.createTime }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :column="1">
                <a-descriptions-item :label="$t('问题描述')">{{ model.exceptionDescription }}</a-descriptions-item>
                <a-descriptions-item :label="$t('处理前图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==1"
                >
                  <div v-if="item.type==1">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="1" v-if="model.whetherToSolve==1">
                <a-descriptions-item :label="$t('处理后图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list" v-if="model.whetherToSolve==1">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==2"
                >
                  <div v-if="item.type==2">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="1">
                <a-descriptions-item :label="$t('是否现场已解决')">
                  <a-tag :color="model.whetherToSolve==1?'green':model.whetherToSolve==2?'red':''">
                    {{ model.whetherToSolve==1?$t('已解决'):model.whetherToSolve==2?$t('未解决'):'' }}
                  </a-tag>
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :title="$t('确认信息')" :column="1">
                <a-descriptions-item :label="$t('确认人')">{{ model.approverName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('确认描述')">{{ model.reason }}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <a-divider orientation="left">{{ $t('处理信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('处理图片')" prop="resolvedPicture">
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="model.resolvedPicture"></j-image-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('处理描述')" prop="resolvedRemark">
                <a-textarea v-model="model.resolvedRemark" :placeholder="$t('请输入处理描述')" :rows="3" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal
      :title="$t('预览')"
      :body-style="{ height: '480px' }"
      :visible="visiblePirture"
      :maskClosable="false"
      @cancel="visiblePirture = false"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <img :src="viewUrl" alt="" style="width: 100%; height: 100%" />
    </j-modal>
  </j-modal>
</template>
  
  <script>
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import { httpAction, getAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
export default {
  name: 'modal',
  components: {
    JSelectUserByDep,
    JImageUpload
  },
  data() {
    return {
      tips: this.$t('普通处理界面'),
      title: this.$t('处理'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      url: {
        edit: "/jeecg-engineering/InspectionWorkOrderController/exampleModifyTheInspectionWorkOrder",
        workOrderDetails: '/jeecg-engineering/InspectionWorkOrderController/workOrderDetails',
      },
      model: {},
      filterDictTextByCache: filterDictTextByCache,
      visiblePirture: false,
      viewUrl: '',
    }
  },
  computed: {
    validatorRules () {
      return {
        handlePictureUrl: [
          { required: true, message: this.$t('请选择处理照片'), trigger: 'change' }
        ],
        handleReason: [
          { required: true, message: this.$t('请输入处理描述'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(row) {
      this.visible = true
      this.disableSubmit = false
      getAction(this.url.workOrderDetails, { id: row.id }).then(res => {
        if (res.success) {
          this.model = Object.assign({}, res.result)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    userChange(id,name){
      this.$set(this.model, 'userId', id)
      this.$set(this.model, 'userName', name)
    },
    handleOk(){
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.confirmLoading = true
          let params = JSON.parse(JSON.stringify(this.model))
          params.status = 4;
          httpAction(this.url.edit, params, 'post').then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.confirmLoading = false
              this.close()
              this.$emit('ok')
            }else{
              this.$message.warning(res.message)
            }
          })
        }
      })
    },

    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    viewPicture(item) {
      if (item.fileType == 'image') {
        this.visiblePirture = true
        this.viewUrl = item.url
      }
    },
  },
}
</script>
<style lang="less" scoped>
.img-list {
  display: flex;
  .img-box {
    width: 150px;
    height: 150px;
    margin: 5px;
    cursor: pointer;
    border-radius: 4px;
    div{
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      video {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }
}
</style>